import React from 'react';

import { Container } from './RoFormLabel.styles';

const RoFormLabel = props => <Container>{props.children}</Container>;

export default RoFormLabel;
